module.exports = __webpack_public_path__ + "img/MEDIA107.b5f4e292.jpg";